import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { courseService } from "../../../_services";
import CategoryHero from "./CategoryHero";
import axiosInstance from "../../../axios";
import MostPopularCourse from "./MostPopularCourse";
import CourseDurationAndFees from "./CourseDurationAndFees";
import NeedHelpFindingYourProgram from "./NeedHelpFindingYourProgram";
import { useSelector } from "react-redux";

export default function CategoryDetails() {
    const { courses, isFetching } = useSelector(state => state?.course || []);
    const courseList = courses?.all?.courses || [];
    const { slug, id } = useParams();
    const location = useLocation();
    const { category } = location.state || {};
    const [fetchCourse, setFetchCourse] = useState([]);
    const [course, setCourse] = useState([]);


    useEffect(() => {
        if (courseList && category) {
            const relatedCourses = courseList.filter(
                (item) => item.category === category.categoryName
            );
            setFetchCourse(relatedCourses);
        }
    }, [courseList, category]);

    return (
        <>
            <CategoryHero category={category} />
            <MostPopularCourse category={category} course={fetchCourse} />
            <CourseDurationAndFees category={category} course={fetchCourse} />
            {/* <NeedHelpFindingYourProgram course={fetchCourse} /> */}
        </>
    );
}